import(/* webpackMode: "eager", webpackExports: ["PasswordResetForm"] */ "/vercel/path0/app/(auth)/auth/_components/password-reset-form.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Footer"] */ "/vercel/path0/components/footer.tsx");
